/**
 * Workflow API — exact mirror of RW-ERP-Service `getWorkflowData()` in
 * `src/api/metaData/meta-data.api.ts` line 58.
 *
 *   POST {API_BASE_URL}/v1/users/workflows/workflow/search
 *   body: empty composite filter (returns all workflows the user can see)
 *
 * Returns the raw response body (`response.data`). The shape is
 * `{ data: { workflowDetails: { [workflowId]: ... } } }`. Unwrapping +
 * caching live in `src/stores/workflow-store.ts` to match the Vue
 * `api → store → page` layering.
 */
import apiClient from '../config/axios.config';
import type { WorkflowResponse } from '../types/workflow';

const WORKFLOW_ENDPOINT = '/api/v1/users/workflows/workflow/search';

interface CompositeFilterRequest {
  type: 'compositeFilter';
  logicalOperator: 'AND';
  filters: never[];
}

export interface WorkflowApiBody {
  data?: {
    workflowDetails?: WorkflowResponse;
  };
}

export async function getWorkflowData(): Promise<WorkflowApiBody> {
  const requestBody: CompositeFilterRequest = {
    type: 'compositeFilter',
    logicalOperator: 'AND',
    filters: [],
  };

  const response = await apiClient.post<WorkflowApiBody>(
    WORKFLOW_ENDPOINT,
    requestBody,
  );
  return response.data;
}
